import { Navigate, Route } from 'react-router-dom';

import PatientPage from '../pages/patient/PatientPage';

import { createLazyRoute } from './utils/createLazyRoute';

/**
 * 환자 관련 라우트
 */
export const patientRoutes = (
  <Route path="patient" element={<PatientPage />}>
    <Route
      path="summary"
      {...createLazyRoute(() => import('../pages/dashboard/patient/PatientDashboardContents'))}
    />
    <Route path="dashboard" {...createLazyRoute(() => import('../pages/dashboard/org/DashboardContents'))} />
    <Route path="survey" {...createLazyRoute(() => import('./components/SurveyContentsWrapper'))} />
    <Route path="survey/send" {...createLazyRoute(() => import('./components/SurveySendContentsWrapper'))} />
    <Route
      path="eeg/history"
      {...createLazyRoute(() =>
        import('@MP/features/scan').then(({ EEGHistoryContents }) => ({ default: EEGHistoryContents }))
      )}
    />
    <Route path="eeg/modules" {...createLazyRoute(() => import('./components/EEGModuleChoiceContents'))} />
    <Route
      path="eeg/prepare"
      {...createLazyRoute(() =>
        import('@MP/features/scan').then(({ EEGPrepareContents }) => ({ default: EEGPrepareContents }))
      )}
    />
    <Route
      path="eeg/measure"
      {...createLazyRoute(() =>
        import('@MP/features/scan').then(({ EEGMeasureContents }) => ({ default: EEGMeasureContents }))
      )}
    />
    <Route
      path="eeg/compare"
      {...createLazyRoute(() =>
        import('@MP/features/scan').then(({ EEGCompareContents }) => ({ default: EEGCompareContents }))
      )}
    />
    <Route
      path="hrv/history"
      {...createLazyRoute(() =>
        import('@MP/features/scan').then(({ HRVHistoryContents }) => ({ default: HRVHistoryContents }))
      )}
    />
    <Route path="hrv/modules" {...createLazyRoute(() => import('./components/HRVModuleChoiceContents'))} />
    <Route
      path="hrv/measure"
      {...createLazyRoute(() =>
        import('@MP/features/scan').then(({ HRVMeasureContents }) => ({ default: HRVMeasureContents }))
      )}
    />
    <Route
      path="sleep"
      {...createLazyRoute(() => import('@MP/features/sleep').then(({ SleepContents }) => ({ default: SleepContents })))}
    />
    {/* <Route
      path="scan-mini"
      {...createLazyRoute(() =>
        import('@MP/features/scan-mini').then(({ ScanMiniContents }) => ({ default: ScanMiniContents }))
      )}
    /> */}
    <Route
      path="stim-home"
      {...createLazyRoute(() =>
        import('@MP/features/stim-home').then(({ StimHomeContents }) => ({ default: StimHomeContents }))
      )}
    />
    <Route path="" element={<Navigate to={`/patient/summary`} replace />} />
  </Route>
);
